import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {TABLE_EXPANSION_TOGGLE_POSITION, TABLE_EXPANSION_TOGGLE_STYLE} from '@aviary/injection-tokens/app-provided.tokens';
import {ExpansionTogglePosition, ExpansionToggleStyle} from '@aviary/components/table/table.component.types';

export function provideAviaryTableExpansionSettings(style: ExpansionToggleStyle, position: ExpansionTogglePosition): EnvironmentProviders {
  return makeEnvironmentProviders([
    {provide: TABLE_EXPANSION_TOGGLE_STYLE, useValue: style},
    {provide: TABLE_EXPANSION_TOGGLE_POSITION, useValue: position}
  ]);
}
